import React from "react";
import { Button, Container, Dialog, Img } from "../../Styles/Global.Styled";
import { css } from "styled-components";
import freshFlowerLogo from "../../assets/Images/fresh_flower_logo_1.png";

const hideStyle = css`
  display: none;
`;
const displayStyle = css`
  display: flex;
`;
const containerStyle = css`
  max-width: 25%;
  flex-direction: column;
  margin-top: -20%;
  background-color: white;
  box-shadow: 0 0 2px 2px green;
  border-radius: 12px;
  padding: 1vh;
  gap: 1vh;
  align-items: center;
  border: 2px solid green;
`;
const widthStyle = css`
  max-width: 100%;
`;
const container1Style = css`
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;
const logoImg = css`
  height: 6vh;
`;
const buttonStyle = css`
  font-family: ${(theme) => theme.testFont};
  padding: 0 0.5vh;
  font-size: 1.75vh;
`;

const PopUp = ({ props, setPopUp }) => {
  
  return (
    <Dialog
      open={props.isOpen}
      $baseStyle={props.mobileOnly && hideStyle}
      $mStyle={props.mobileOnly && displayStyle}
    >
      {!props.isCustom ? (
        <Container $baseStyle={containerStyle} $mStyle={widthStyle}>
          <Container $baseStyle={container1Style}>
            <Img $baseStyle={logoImg} src={freshFlowerLogo} alt="Logo" />
            <Button
              $baseStyle={buttonStyle}
              onClick={() => setPopUp({ isOpen: false })}
            >
              x
            </Button>
          </Container>
          {props.content}
        </Container>
      ) : (
        props.content
      )}
    </Dialog>
  );
};

export default PopUp;
